import React from 'react'
import FeaturedStory from './FeaturedStory'
import FeaturedStoryLinkUrl from './FeaturedStoryLinkUrl'

export default function FeaturedStoryFactory({story}) {

  if(story.storyType === 'imageUrl'){
    return <FeaturedStoryLinkUrl story={story} />
  }

  return <FeaturedStory story={story} />
}